import React, { useState } from 'react'
import dayjs from 'dayjs'
import { ChangeEvent } from 'react'
import NumberFormat from 'react-number-format'
import errorAlert from '../../../assets/images/error-alert.svg'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducers } from '../../../redux/reducers'
import { WatDatePicker } from '../../../component/datePicker'
import '../style.css'
import * as paymentDetailAction from '../../../redux/actions/paymentDetail.detail.action'
import { PaymentMethodModel } from '../../../models/paymentMethod'
import { DocumentDetailModel } from '../../../models/documentDetail'
import { PayInBank } from '../../../component/entryForm/bankAccount'
import { PAYMENTMODE } from '../../../constants'
import { getBankName } from '../../../helpers/texthelper'
interface Form {
  paymentAmount: number | null
  payInToBank: string
  bankCode: string
  accountNo: string
  remarkMoneyType: string
  payInDate: string
  id: number
  paymentMethod?: PaymentMethodModel
}

interface ICashPayIn {
  setPaymentDetailFormValue: (form: any) => void
  data: DocumentDetailModel
  documentId: number
}

export const CashPayIn = ({ data, setPaymentDetailFormValue, documentId }: ICashPayIn) => {
  const dispatch = useDispatch()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [form, setForm] = useState<Form>({
    paymentAmount: data.paymentAmount || null,
    payInToBank: data.payInToBank || '',
    bankCode: data.bankCode || '',
    accountNo: data.accountNo || '',
    remarkMoneyType: data.remarkMoneyType || '',
    payInDate: data.payInDate || '',
    id: data.id || 0,
    paymentMethod: data.paymentMethod
  })
  const loginState = useSelector((state: RootReducers) => state.loginReducer)
  const [formErrors, setFormErrors] = useState<any>({})

  const onChangeAmountObject = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    const amount = value.replace(/,/g, '')
    setForm({
      ...form,
      paymentAmount: Number(amount)
    })

    if ('paymentAmount' in formErrors && formErrors['paymentAmount']) {
      setFormErrors({
        ...formErrors,
        paymentAmount: false
      })
    }
  }

  const handleSelect = (updateValue: any) => {
    setForm({
      ...form,
      ...updateValue
    })
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    setForm({
      ...form,
      [name]: value
    })

    if (name in formErrors && formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false
      })
    }
  }

  const handlePayInDateChange = (christDate: any, buddhistDate: any) => {
    setForm({
      ...form,
      payInDate: christDate
    })

    if ('payInDate' in formErrors && formErrors['payInDate']) {
      setFormErrors({
        ...formErrors,
        payInDate: false
      })
    }
  }

  const onSubmit = () => {
    debugger
    const errors = validateAllValue()
    const keysArray = Object.keys(errors)
    const count = keysArray?.length
    if (count > 0) {
      return
    }
    const body: any = {
      ...data,
      ...form
    }
    setIsSubmitting(true)
    setPaymentDetailFormValue(body)
    dispatch(paymentDetailAction.updatePaymentDetail(documentId, body))
    setIsSubmitting(false)
  }
  const onCancelClick = () => {
    const body: any = {
      ...data,
      ...form
    }
    setPaymentDetailFormValue(body)
  }

  const validateAllValue = () => {
    const exceptionalFields = ['remarkMoneyType']
    const allErrors = {}

    Object.keys(form).forEach((key: string) => {
      const k = key as keyof Form
      const value = form[k]
      console.log(k, value)
      if (!value && !exceptionalFields.includes(k)) {
        Object.assign(allErrors, { [k]: true })
      }
    })
    setFormErrors(allErrors)
    return allErrors
  }

  return (
    <div className="container-inf">
      <div className="form-content">
        <div className="required">
          <span className="amount-text">Amount</span>
          <NumberFormat
            required
            allowNegative={false}
            thousandSeparator={true}
            prefix=""
            className={`amount-input ${formErrors?.amount && 'error-border-validate'}`}
            inputMode="decimal"
            decimalScale={2}
            onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeAmountObject(e)}
            value={form.paymentAmount}
            disabled={true}
          />
          {formErrors?.paymentAmount && (
            <div className="error-text-validate">
              <img src={errorAlert} alt="ErrorAlert" />
              กรุณากรอกข้อมูล
            </div>
          )}
        </div>
        <div className="required">
          <span className="amount-text">วันที่ฝาก</span>
          <WatDatePicker
            className={`amount-input ${formErrors.payInDate && 'error-border-validate'}`}
            name="payInDate"
            onChange={handlePayInDateChange}
            dateFormat={'yyyy-MM-dd'}
            displayFormat={'DD/MM/YYYY'}
            clearable={false}
            minDate={dayjs().add(-2, 'year')}
            maxDate={dayjs().add(5, 'year')}
            disabled={true}
            readOnly={true}
            yearBoundary={99}
            inputStyle={formErrors.payInDate ? { borderColor: '#b30909' } : null}
            value={form.payInDate}
          />
          {formErrors.payInDate && (
            <div className="error-text-validate">
              <img src={errorAlert} alt="ErrorAlert" />
              กรุณากรอกข้อมูล
            </div>
          )}
        </div>
        {/* <div className="required">
          <PayInBank
            paymentMode={PAYMENTMODE.CASHPAYIN}
            branchCode={loginState.account?.agentInfo.branchCode as string}
            onSelect={bankAccountModelView => {
              const { name, value } = bankAccountModelView.target
              handleSelect({
                [name]: value
              })
            }}
            disabled={true}
            defaultBankCode={form.bankCode}
            defaultAccount={form.accountNo}
            isRequireBank={formErrors?.bankCode}
            isRequireAccountNo={formErrors?.accountNo}
          />
        </div> */}

        <div className="required">
          <span className="amount-text">รายละเอียดการนำฝากเข้าธนาคาร</span>
          <input
            className={`amount-input`}
            type="text"
            name={'bankCode'}
            autoComplete="off"
            disabled={true}
            onChange={handleChange}
            value={getBankName(form.bankCode)}
          />
        </div>

        <div className="required">
          <span className="amount-text">เลขที่บัญชี</span>
          <input
            className={`amount-input`}
            type="text"
            name={'accountNo'}
            autoComplete="off"
            disabled={true}
            onChange={handleChange}
            value={form.accountNo}
          />
        </div>

        <label className="group-label-input">
          <span>หมายเหตุ</span>
          <input
            required
            className={`field-input ${formErrors.remarkMoneyType && 'error-border-validate'}`}
            autoComplete="off"
            type="text"
            name="remarkMoneyType"
            value={form.remarkMoneyType}
            onChange={handleChange}
          />
        </label>
      </div>
      <div className="button-container">
        <button className="cancel-button" onClick={onCancelClick}>
          ยกเลิก
        </button>
        <button className="confirm-paid-button" onClick={onSubmit} disabled={isSubmitting}>
          {isSubmitting ? 'กำลังบันทึกข้อมูล...' : 'ตกลง'}
        </button>
      </div>
    </div>
  )
}
